import {UserFullReport} from "./UserFullReport";
import {UserFullReportMunicipality} from "./UserFullReportMunicipality";

// С8 — Справка по ползвател с корекция (като С3 + колона „Корекция").
// Единствената справка, в която корекцията се вижда (В4).
export const ReportS8 = () => (
    <UserFullReport title="С8 — Справка по ползвател с корекция" variant="correction"
                    showDeals={true} showCorrection={true}/>
);

// Ъ16: С8 за цяла община — всички землища с декларация (без подписен блок, като
// единичната С8).
export const ReportS8Municipality = () => (
    <UserFullReportMunicipality title="С8 — Справка по ползвател с корекция" variant="correction"
                                showDeals={true} showCorrection={true}/>
);
